import type { FC } from 'react';
import { Checkbox, Tooltip } from 'antd';

import { colorConstants } from 'config/colorConstants';

import {
    CHECKBOX_TOOLTIP_OVERLAY_STYLE,
    CHECKBOX_TOOLTIP_SHADOW,
    resolveTooltipText,
    type GenericCheckboxControlProps,
    type GenericCheckboxTooltipListProps,
} from './formControl';

export const GenericCheckboxTooltipList = ({ items }: GenericCheckboxTooltipListProps) => (
    <div
        className="flex w-[214px] flex-col gap-3 rounded-xl bg-white p-5"
        style={{ boxShadow: CHECKBOX_TOOLTIP_SHADOW }}
    >
        {items.map((item) => (
            <div
                key={`${item.label}-${item.value}`}
                className="flex w-full items-start justify-between text-[14px] leading-normal"
            >
                <span style={{ color: colorConstants.toolbarLabelGrey }}>{item.label}</span>
                <span style={{ color: colorConstants.blackTitle }}>{item.value}</span>
            </div>
        ))}
    </div>
);

export const GenericCheckboxControl: FC<GenericCheckboxControlProps> = ({
    checked = false,
    indeterminate = false,
    onChange,
    disabled = false,
    className,
    showTooltip = false,
    tooltipText,
    staticTooltipText,
}) => {
    const resolvedTooltipText = resolveTooltipText(staticTooltipText, tooltipText, undefined);

    const checkbox = (
        <Checkbox
            checked={checked}
            indeterminate={indeterminate}
            disabled={disabled}
            className={`table-checkbox-control ${className ?? ''}`.trim()}
            onChange={(event) => onChange(event.target.checked)}
        />
    );

    if (!showTooltip || !checked || !resolvedTooltipText) return checkbox;

    return (
        <Tooltip
            title={resolvedTooltipText}
            placement="bottom"
            showArrow={false}
            overlayClassName="checkbox-control-tooltip"
            overlayStyle={{ maxWidth: 'none' }}
            overlayInnerStyle={CHECKBOX_TOOLTIP_OVERLAY_STYLE}
            getPopupContainer={() => document.body}
        >
            <span className="inline-flex">{checkbox}</span>
        </Tooltip>
    );
};

export default GenericCheckboxControl;
